function initMyacaseBundle(root){
if(!root||root.dataset.init)return; root.dataset.init="1";
var DATA=JSON.parse(root.querySelector('.kb-data').textContent).products;
var tier=0;
var activeSlot=1;
var plateauInitialized=false;
var PRICE={1:3990,2:6990,3:9490};
var OLD_PRICE={1:3990,2:7980,3:11970};
var FILL={1:33,2:66,3:100};
var CTA_TEXT={
1:function(){return 'Ajouter au panier — '+money(PRICE[1]);},
2:function(){return 'Ajouter 2 trousses — '+money(PRICE[2]);},
3:function(){return 'Ajouter 3 trousses — '+money(PRICE[3]);}
};
var selection={1:null,2:null,3:null};
function $(id){ return root.querySelector('#'+id); }
function money(c){return (c/100).toFixed(2).replace('.',',')+' €';}
function shortName(t){return t.replace('Trousse pour Dyson Airwrap — ','').replace('Trousse pour Dyson Airwrap','Modèle');}
function firstAvailableVariant(p){
var vs=p.variants||[];
var av=vs.filter(function(v){return v.a;});
return av[0]||vs[0]||null;
}
var carouselIndex=0;
var cardEls=[];
var orbitBuilt=false;
function firstEmptySlot(){
for(var i=1;i<=tier;i++){ if(!selection[i]) return i; }
return null;
}
function renderChips(){
$('kbPlateauTitle').textContent = tier===1 ? 'Votre trousse' : tier===3 ? 'Votre trio' : 'Votre duo';
updateSelectedLabels();
}
function isProductChosen(pid){
for(var i=1;i<=tier;i++){ if(selection[i] && String(selection[i].productId)===String(pid)) return true; }
return false;
}
function updateSelectedLabels(){
cardEls.forEach(function(el){
el.classList.toggle('is-chosen', isProductChosen(el.dataset.pid));
});
var grid=$('kbDesktopGrid');
if(grid){
Array.prototype.forEach.call(grid.querySelectorAll('.kb-grid-item'), function(item){
item.classList.toggle('is-chosen', isProductChosen(item.dataset.pid));
});
}
}
function renderPlateauSummary(){
var complete = firstEmptySlot()===null;
var summaryEl=$('kbSummary');
if(!complete){
summaryEl.classList.add('is-hidden');
summaryEl.innerHTML='';
return;
}
var html='<p class="kb-summary-title">Votre sélection</p>';
for(var i=1;i<=tier;i++){
var it=selection[i];
html+='<div class="kb-summary-item"><img src="'+it.img+'" alt=""><span>'+it.name+'</span></div>';
}
summaryEl.innerHTML=html;
summaryEl.classList.remove('is-hidden');
}
function buildOrbitCards(){
if(orbitBuilt)return;
var track=$('kbOrbitTrack');
cardEls=Array.prototype.slice.call(track.querySelectorAll('.kb-orbit-card'));
orbitBuilt = cardEls.length > 0;
buildDesktopGrid();
}
var desktopGridBuilt=false;
function buildDesktopGrid(){
if(desktopGridBuilt)return;
var grid=$('kbDesktopGrid');
if(!grid)return;
var html='';
DATA.forEach(function(p,i){
html+='<div class="kb-grid-item" data-idx="'+i+'" data-pid="'+p.id+'"><span class="kb-chosen-badge">Produit sélectionné !</span><img src="'+p.img+'" alt=""><span class="kb-grid-name">'+shortName(p.t)+'</span></div>';
});
grid.innerHTML=html;
desktopGridBuilt=true;
}
function updateDominant(){
cardEls.forEach(function(el,i){ el.classList.toggle('is-dominant', i===carouselIndex); });
}
function centerOnIndex(idx, smooth){
var el=cardEls[idx];
if(!el||!trackEl)return;
var trackRect=trackEl.getBoundingClientRect();
var elRect=el.getBoundingClientRect();
var offset=(elRect.left+elRect.width/2)-(trackRect.left+trackRect.width/2);
var target=trackEl.scrollLeft+offset;
trackEl.scrollTo({left:target, behavior: smooth ? 'smooth' : 'auto'});
}
function getCenteredIndex(){
if(!trackEl||cardEls.length===0)return carouselIndex;
var trackRect=trackEl.getBoundingClientRect();
var centerX=trackRect.left+trackRect.width/2;
var best=0, bestDist=Infinity;
cardEls.forEach(function(el,i){
var r=el.getBoundingClientRect();
var c=r.left+r.width/2;
var d=Math.abs(c-centerX);
if(d<bestDist){ bestDist=d; best=i; }
});
return best;
}
function previewOnly(idx){
carouselIndex = ((idx % DATA.length)+DATA.length) % DATA.length;
centerOnIndex(carouselIndex, true);
updateDominant();
}
var ORDINALS={1:'premier',2:'deuxième',3:'troisième'};
function updateValidateUI(){
var lbl=$('kbGridLabel');
if(!lbl) return;
if(tier===1){
lbl.textContent='Sélectionne ton modèle';
} else {
var ord=ORDINALS[activeSlot]||(activeSlot+'e');
lbl.textContent='Sélectionne ton '+ord+' modèle';
}
}
function validateCurrentModel(){
var p=DATA[carouselIndex];
var v=firstAvailableVariant(p);
selection[activeSlot]={productId:p.id,variantId:v?v.id:null,img:p.img,name:shortName(p.t)};
renderChips();
renderPlateauSummary();
updateCtaDisabled();
var isLast = activeSlot>=tier;
if(isLast){
addToCart(null, null, '');
} else {
activeSlot=activeSlot+1;
var existing=selection[activeSlot];
if(existing){
var idx=-1;
for(var k=0;k<DATA.length;k++){ if(String(DATA[k].id)===String(existing.productId)){ idx=k; break; } }
carouselIndex = idx>=0 ? idx : 0;
centerOnIndex(carouselIndex, true);
}
renderChips();
updateDominant();
updateValidateUI();
}
}
function enterPlateau(fullReset){
buildOrbitCards();
if(fullReset){
selection[1]=null; selection[2]=null; selection[3]=null;
activeSlot=1;
} else {
var next=firstEmptySlot();
if(next){ activeSlot=next; }
else if(activeSlot>tier){ activeSlot=tier; }
}
renderChips();
var existing=selection[activeSlot];
if(existing){
var idx=-1;
for(var k=0;k<DATA.length;k++){ if(String(DATA[k].id)===String(existing.productId)){ idx=k; break; } }
carouselIndex = idx>=0 ? idx : 0;
} else {
carouselIndex = 0;
}
centerOnIndex(carouselIndex, false);
updateDominant();
updateDesktopGridSelection();
renderPlateauSummary();
updateCtaDisabled();
updateValidateUI();
}
var trackEl;
var scrollSettleTimeout=null;
function onTrackScroll(){
if(scrollSettleTimeout) clearTimeout(scrollSettleTimeout);
scrollSettleTimeout = setTimeout(function(){
carouselIndex = getCenteredIndex();
updateDominant();
}, 120);
}
function updateDesktopGridSelection(){
var grid=$('kbDesktopGrid');
if(!grid)return;
var cur=selection[activeSlot];
Array.prototype.forEach.call(grid.querySelectorAll('.kb-grid-item'), function(el){
el.classList.toggle('is-selected', !!cur && String(el.dataset.pid)===String(cur.productId));
});
}
function desktopSelectAndAdvance(idx){
var p=DATA[idx];
if(!p)return;
var v=firstAvailableVariant(p);
selection[activeSlot]={productId:p.id,variantId:v?v.id:null,img:p.img,name:shortName(p.t)};
renderChips();
renderPlateauSummary();
updateCtaDisabled();
updateDesktopGridSelection();
var isLast = activeSlot>=tier;
if(isLast){
addToCart(null, null, '');
} else {
activeSlot=activeSlot+1;
renderChips();
updateDesktopGridSelection();
updateValidateUI();
}
}
function initOrbitInteractions(){
trackEl=$('kbOrbitTrack');
trackEl.addEventListener('scroll', onTrackScroll, {passive:true});
trackEl.addEventListener('click', function(e){
var card=e.target.closest('.kb-orbit-card');
if(!card)return;
var idx=parseInt(card.dataset.idx,10);
if(idx===carouselIndex){
validateCurrentModel();
} else {
previewOnly(idx);
}
});
window.addEventListener('resize', function(){ centerOnIndex(carouselIndex, false); });
var desktopGridEl=$('kbDesktopGrid');
if(desktopGridEl){
desktopGridEl.addEventListener('click', function(e){
var item=e.target.closest('.kb-grid-item');
if(!item)return;
var idx=parseInt(item.dataset.idx,10);
desktopSelectAndAdvance(idx);
});
}
}
function updateCtaText(){
var label = (tier && CTA_TEXT[tier]) ? CTA_TEXT[tier]() : 'Ajouter au panier';
var ctaText=$('kbCtaText');
if(ctaText) ctaText.textContent = label;
}
function updateCtaDisabled(){
var incomplete = !tier || firstEmptySlot()!==null;
kbCtaBtn.disabled = incomplete;
kbCtaBtn.setAttribute('aria-disabled', incomplete ? 'true':'false');
}
function refreshAll(){
updateCtaText();
updateCtaDisabled();
}
root.querySelector('.kb-p1').textContent=money(PRICE[1]);
root.querySelector('.kb-p2').textContent=money(PRICE[2]);
root.querySelector('.kb-o2').textContent=money(OLD_PRICE[2]);
root.querySelector('#kbSave2').textContent='Économisez '+money(OLD_PRICE[2]-PRICE[2]);
root.querySelector('.kb-p3').textContent=money(PRICE[3]);
root.querySelector('.kb-o3').textContent=money(OLD_PRICE[3]);
root.querySelector('#kbSave3').textContent='Économisez '+money(OLD_PRICE[3]-PRICE[3]);
function movePlateauAfterOffer(t){
var offerEl=root.querySelector('.kb-offer[data-tier="'+t+'"]');
var plateauEl=$('kbPlateau');
if(!offerEl||!plateauEl)return;
offerEl.parentNode.insertBefore(plateauEl, offerEl.nextSibling);
}
function select(t){
tier=t;
root.querySelectorAll('.kb-offer').forEach(function(o){o.classList.toggle('is-on',parseInt(o.dataset.tier,10)===t);});
var fill=$('kbFill'); if(fill) fill.style.width=(FILL[t]||100)+'%';
movePlateauAfterOffer(t);
var plateauEl=$('kbPlateau'); if(plateauEl) plateauEl.style.display='block';
if(!plateauInitialized){
plateauInitialized=true;
refreshAll();
enterPlateau(true);
} else {
refreshAll();
enterPlateau(false);
}
}
root.querySelectorAll('.kb-offer').forEach(function(o){
o.addEventListener('click',function(){select(parseInt(o.dataset.tier,10));});
});
var kbCtaBtn = $('kbCta');
var kbCtaTextEl = $('kbCtaText');
initOrbitInteractions();
var fill=$('kbFill'); if(fill) fill.style.width='0%';
refreshAll();
function buildItems(){
var items=[];
var slots=[];
if(tier>=1)slots.push(1);
if(tier>=2)slots.push(2);
if(tier>=3)slots.push(3);
var ok=slots.length>0;
slots.forEach(function(s){
if(selection[s]&&selection[s].variantId){
items.push({id:parseInt(selection[s].variantId,10),quantity:1});
} else {
ok=false;
}
});
return ok ? items : null;
}
function addToCart(triggerBtn, triggerLabelEl, defaultLabel){
var items=buildItems();
if(!items||items.length<tier){var noteEl=$('kbNote'); if(noteEl) noteEl.textContent='Choisis un modèle pour chaque trousse.';return;}
if(triggerBtn) triggerBtn.style.opacity=.7;
if(triggerLabelEl) triggerLabelEl.textContent='Ajout…';
fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
.then(function(r){
return r.json().then(function(data){
if(!r.ok){
var msg=(data && data.description) ? data.description : 'Une erreur est survenue.';
throw new Error(msg);
}
return data;
});
})
.then(function(){window.location.href='/cart';})
.catch(function(err){
var noteEl=$('kbNote');
if(noteEl) noteEl.textContent=(err && err.message) ? err.message : 'Une erreur est survenue. Merci de réessayer.';
if(triggerBtn) triggerBtn.style.opacity=1;
if(triggerLabelEl) triggerLabelEl.textContent=defaultLabel;
});
}
kbCtaBtn.addEventListener('click',function(){
if(kbCtaBtn.disabled) return;
addToCart(kbCtaBtn, kbCtaTextEl, CTA_TEXT[tier] ? CTA_TEXT[tier]() : 'Ajouter au panier');
});
}
document.querySelectorAll('.kb:not([data-init])').forEach(function(el){
initMyacaseBundle(el);
});